import { NUMBERS_ONLY } from '@/utils/constants/regex'

// Function checks if strings characters match and then returns matched casing
export function matchStringCase(original: string, newString: string) {
  for (let i = 0; i < newString.length; i++) {
    if (original[i] !== newString[i].toLowerCase() && original[i] !== newString[i].toUpperCase()) {
      return null
    }
  }

  return original
    .split('')
    .map((char, i) => {
      if (i < newString.length) {
        return newString[i] === newString[i].toUpperCase() ? char.toUpperCase() : char.toLowerCase()
      }
      return char
    })
    .join('')
}

export const escapeSpecialCharacters = (string: string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

const MATCH_HTML_TAGS = /<\/?[^>]+(>|$)/g
export const removeHtmlTags = (text: string) => text.replace(MATCH_HTML_TAGS, '')

export const formatPnr = (value: string | undefined) => {
  if (!value) return ''

  if (NUMBERS_ONLY.test(value) && value.length === 7) {
    return `${value.slice(0, 3)}-${value.slice(3)}`
  }
  return value
}

export const hasStringValue = (value?: string): value is string => {
  return value != null && value.trim() !== ''
}
